import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, LockIcon, DownloadIcon } from 'lucide-react';
const KIT_URL = 'https://digital-solvex-ar.myshopify.com/cart/48681186394369:1';
const lineItems = [{
  emoji: '📊',
  name: 'Sistema ML Rentable',
  price: '$34.900'
}, {
  emoji: '📦',
  name: 'Tracker de Stock',
  price: '$24.900'
}, {
  emoji: '🚀',
  name: 'Sistema Escalado 90 Días',
  price: '$39.900'
}, {
  emoji: '🎁',
  name: 'Guía 5 Errores (BONO)',
  price: '$19.900'
}, {
  emoji: '🎁',
  name: 'Pack Plantillas (BONO)',
  price: '$14.900'
}];
export function PriceAnchorSection() {
  return <section className="bg-navy py-16 md:py-24" data-id="element-193">
      <div className="max-w-3xl mx-auto px-4 md:px-8" data-id="element-194">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-navy-dark border border-white/10 rounded-3xl p-8 md:p-12" data-id="element-195">
          <h3 className="text-gold font-display font-bold text-xl mb-8 text-center" data-id="element-196">
            Lo que recibís hoy:
          </h3>

          <ul className="space-y-4 mb-8" data-id="element-197">
            {lineItems.map((item, i) => <li key={i} className="flex items-center justify-between text-white/70" data-id="element-198">
                <span className="flex items-center gap-2 text-sm md:text-base" data-id="element-199">
                  <span data-id="element-200">{item.emoji}</span>
                  <span data-id="element-201">{item.name}</span>
                </span>
                <span className="text-white/40 line-through text-sm" data-id="element-202">{item.price}</span>
              </li>)}
          </ul>

          <div className="h-px bg-gold/30 mb-8" data-id="element-203" />

          <div className="text-center mb-2" data-id="element-204">
            <span className="text-white/40 text-lg line-through" data-id="element-205">
              Valor total real: $134.500
            </span>
          </div>
          <div className="text-center mb-2" data-id="element-206">
            <span className="text-white/60 text-lg" data-id="element-207">Tu inversión hoy:</span>
          </div>
          <div className="text-center mb-3" data-id="element-208">
            <span className="font-display font-extrabold text-5xl md:text-6xl gold-shine" data-id="element-209">
              $62.900
            </span>
          </div>
          <p className="text-teal text-center font-semibold mb-8" data-id="element-210">
            Ahorrás $71.600 — 53% de descuento
          </p>

          <a href={KIT_URL} className="btn-gold block w-full text-center text-lg py-4 rounded-xl font-extrabold mb-6 no-underline" data-id="element-211">
            QUIERO EL KIT COMPLETO — $62.900 →
          </a>

          <div className="flex items-center justify-center gap-4 md:gap-6 text-white/40 text-xs md:text-sm" data-id="element-212">
            <span className="flex items-center gap-1.5" data-id="element-213">
              <ZapIcon className="w-4 h-4" data-id="element-214" /> Descarga inmediata
            </span>
            <span className="flex items-center gap-1.5" data-id="element-215">
              <LockIcon className="w-4 h-4" data-id="element-216" /> Pago seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-217">
              <DownloadIcon className="w-4 h-4" data-id="element-218" /> Acceso instantáneo
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}